/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import '../styles/layout.css';

import { graphql,useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useEffect,useState } from 'react';

import Footer from './footer';
import Menu from './menu';
import MenuMobile from './menu-mobile';

const Layout = ( { children, header } ) => {
  const data = useStaticQuery( graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  ` );

  useEffect( () => {
    if ( innerWidth < 991 ) {
      isMobile( true );
    }
  }, [innerWidth] );

  const [mobile, isMobile] = useState( false );
  const [ showNav, toggleNav ] = useState( true );
  const [modal, modalState] = useState( false );
  function modalChanged() {
    modalState( !modal );
  }
  let innerWidth = 992;
  // const { innerWidth } = window;
  if ( typeof window !== 'undefined' ) {
    innerWidth = window.innerWidth;
  }

  useEffect( () => {
    if ( innerWidth < 991 ) {
      isMobile( true );
    }
  }, [innerWidth] );


  return (
    <>
      {
        mobile
          ?
          <MenuMobile
            modalOpen={modal}
            modalChanged={modalChanged}/>
          :
          <Menu />
      }

      {/* :
          <Header siteTitle={data.site.siteMetadata?.title || `Title`} toggleNavBar={() => toggleNav(!showNav)} />
      } */}

      <div

        style={( !header && innerWidth < 991 && showNav ) ? { marginTop: '0' } : { margin: '0 auto', marginTop: '0' }}
      >
        <main>{children}</main>

        {/* <footer style={{
          marginTop: `2rem`
        }}>
          © {new Date().getFullYear()}, Copyright
          {` `}
          <a href="https://www.GetMyBubble.com">Bubble Insurance Inc</a>
        </footer> */}
      </div>

      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
